module.exports = __webpack_public_path__ + "static/img/Didier.7be78b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Didier.jpg
// module id = jrBm
// module chunks = 1